import classNames from "classnames";
import { TextIcon } from "components/atoms/TextIcon";
import { Typography } from "components/atoms/Typography";
import { useScreenSize } from "hooks";
import { TAB_WIDTH, MOBILE_WIDTH } from "utils/constants";
import { ButtonsByContentObjectTypes } from "../ButtonsByContentObjectTypes";
import "./index.scss";

interface IProps {
  /**The background color changes based on the index of the data, determining whether it is even or odd*/
  index: number;
  textIconLabel: string;
  iconType?: undefined | "yellow-timer" | "select" | "empty-circle" | "lock";
  /**If the parameter "isbtn" is set to true, then the label should be displayed only in the right button*/
  btnLabel?: string;
  middleLabel?: string | null;
  /**If the "isbtn" parameter is set to true, only the right button will be displayed*/
  isBtn?: boolean;
  /**If the "isSecondBtn" parameter is set to true, only the left button will be displayed*/
  isSecondBtn?: boolean;
  /**If the parameter "isSecondBtn" is set to true, then the label should be displayed only in the left button*/
  secondBtnLabel?: string;
  isMobile: boolean;
  handlePrimaryBtnClick?: () => any;
  handleSecondaryBtnClick?: () => any;
  contentObjectType?: string;
  rowId?: string;
  isHideButtons?: boolean;
  theme: "light" | "dark";
  itemPageNo?: number;
  type?: any;
  status: string;
  drillSmartResult?: any; // DrillSmartResult object for DrillSmart items
  badge?: string; // Badge to show (e.g., "DrillSmart")
}

export const ClassHomeWorkRow = ({
  index,
  textIconLabel,
  iconType,
  btnLabel,
  middleLabel,
  isSecondBtn,
  secondBtnLabel,
  isBtn,
  isMobile,
  handlePrimaryBtnClick,
  handleSecondaryBtnClick,
  contentObjectType,
  rowId,
  isHideButtons,
  theme,
  type,
  itemPageNo,
  status,
  drillSmartResult,
  badge,
}: IProps) => {
  const screen = useScreenSize();
  
  return (
    <div
      className={classNames(
        "class-home-work-row-wrapper",
        {
          "bg-white": index % 2 === 0,
          "bg-blue": index % 2 !== 0,
          "no-buttons": isHideButtons,
        },
        screen.width > MOBILE_WIDTH && screen.width <= TAB_WIDTH
          ? "tab-style"
          : ""
      )}
      id={rowId ? `${rowId}` : ""}
    >
      {screen.width <= 1550 ? (
        <div className="home-tab-size-wrapper">
          <div className="icon-text-section">
            <TextIcon
              label={textIconLabel}
              badge={badge}
              icon={true}
              isReverse={true}
              iconType={iconType}
              isTabStyle={true}
              theme={theme}
            />
          </div>

          <div className="middle-section">
            {middleLabel && (
              <Typography
                variant="h8Med"
                label={middleLabel}
                styles="custom-middle-home-style"
              />
            )}
          </div>
        </div>
      ) : (
        <>
          <div className="icon-text-section">
            <TextIcon
              label={textIconLabel}
              badge={badge}
              icon={true}
              isReverse={true}
              iconType={iconType}
              isTabStyle={true}
              theme={theme}
            />
          </div>

          <div className="middle-section">
            {middleLabel && (
              <Typography
                variant="h8Med"
                label={middleLabel}
                styles="custom-middle-home-style"
              />
            )}
          </div>
        </>
      )}
      <div className={classNames("btn-section")}>
        <ButtonsByContentObjectTypes
          status={status}
          contentObjectType={contentObjectType}
          handlePrimaryBtnClick={handlePrimaryBtnClick}
          handleSecondaryBtnClick={handleSecondaryBtnClick}
          drillSmartResult={drillSmartResult}
        />
      </div>
    </div>
  );
};
